export default __webpack_public_path__ + "static/media/moveIcon.c62b8a99.svg";